import { useState } from "react";
import { useAuth } from "../../context/AuthContext";

const API_URL = process.env.REACT_APP_API_URL;

const initialForm = {
  name: "",
  email: "",
  phone: "",
};

const UseModalConfirmReceiptOrder = (refetchTripsNegotiations) => {
  const [
    showSuccessScreenConfirmReceiptOrder,
    setShowSuccessScreenConfirmReceiptOrder,
  ] = useState(false);
  const [isOpenConfirmReceiptOrder, setIsOpenConfirmReceiptOrder] =
    useState(false);

  const [
    selectedNegotiationConfirmReceiptOrder,
    setSelectedNegotiationConfirmReceiptOrder,
  ] = useState(null);

  const [formDataConfirmReceiptOrder, setFormDataConfirmReceiptOrder] =
    useState(initialForm);

  const [errorsConfirmReceiptOrder, setErrorsConfirmReceiptOrder] = useState(
    {},
  );

  const [loadingConfirmReceiptOrder, setLoadingConfirmReceiptOrder] =
    useState(false);

  const [errorConfirmReceiptOrder, setErrorConfirmReceiptOrder] = useState("");

  const [successConfirmReceiptOrder, setSuccessConfirmReceiptOrder] =
    useState("");

  const { authFetch } = useAuth();

  const validateEmail = (email) => {
    const value = email.trim();

    if (!value) return "Email é obrigatório";

    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!regex.test(value)) return "Email inválido";

    return "";
  };

  const handlePhoneChange = (value) => {
    let raw = value.replace(/\D/g, "");

    if (raw.length > 11) {
      raw = raw.slice(0, 11);
    }

    raw = raw.replace(/^(\d{2})(\d)/, "($1) $2");

    raw = raw.replace(/(\d{5})(\d)/, "$1-$2");

    setFormDataConfirmReceiptOrder((prev) => ({
      ...prev,
      phone: raw,
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    return Object.keys(newErrors).length === 0;
  };

  const openModalConfirmReceiptOrder = (negotiation, status) => {
    setSelectedNegotiationConfirmReceiptOrder(negotiation);

    //console.log(negotiation?.receiver);

    setFormDataConfirmReceiptOrder({
      img: negotiation?.receiver?.imagem || "",
      name: negotiation?.receiver?.nome || "",
      email: negotiation?.receiver?.email || "",
      phone: negotiation?.receiver?.phone || "",
      temporary_receiver: negotiation?.receiver_data || "",
      is_confirmed: negotiation?.is_receiver_data_confirmed || "",
      is_receiver_readded: status,
    });

    setErrorConfirmReceiptOrder("");

    setSuccessConfirmReceiptOrder("");

    setShowSuccessScreenConfirmReceiptOrder(false);

    setIsOpenConfirmReceiptOrder(true);
  };

  const closeModalConfirmReceiptOrder = () => {
    setIsOpenConfirmReceiptOrder(false);

    setSelectedNegotiationConfirmReceiptOrder(null);

    setFormDataConfirmReceiptOrder(initialForm);

    setErrorsConfirmReceiptOrder({});

    setErrorConfirmReceiptOrder("");

    setShowSuccessScreenConfirmReceiptOrder(false);

    setSuccessConfirmReceiptOrder("");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormDataConfirmReceiptOrder((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrorsConfirmReceiptOrder((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;

    let errorMessage = "";

    setErrorsConfirmReceiptOrder((prev) => ({
      ...prev,
      [name]: errorMessage,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedNegotiationConfirmReceiptOrder?.serie_trip_negotiations) {
      setErrorConfirmReceiptOrder("Nenhuma negociação selecionada.");
      return;
    }

    //console.log(formDataConfirmReceiptOrder);
    //return;

    try {
      setLoadingConfirmReceiptOrder(true);

      setErrorConfirmReceiptOrder("");

      setSuccessConfirmReceiptOrder("");

      const response = await authFetch(
        `${API_URL}/api/trip-negotiations/${selectedNegotiationConfirmReceiptOrder.serie_trip_negotiations}/confirm-receipt-order/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            //Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify({
            status_order: 1,
          }),
        },
      );

      let data = {};

      try {
        data = await response.json();
      } catch (err) {
        data = {};
      }

      if (!response.ok) {
        throw new Error(
          data?.detail || data?.message || "Não foi possível enviar os dados.",
        );
      }

      setSuccessConfirmReceiptOrder(
        data?.detail || data?.message || "Dados enviados com sucesso.",
      );
      setShowSuccessScreenConfirmReceiptOrder(true);
      await refetchTripsNegotiations();
    } catch (err) {
      setErrorConfirmReceiptOrder(
        err.message || "Não foi possível enviar os dados.",
      );
      setTimeout(() => {
        setErrorConfirmReceiptOrder("");
      }, 2000);
    } finally {
      setLoadingConfirmReceiptOrder(false);
    }
  };

  return {
    isOpenConfirmReceiptOrder,
    showSuccessScreenConfirmReceiptOrder,
    openModalConfirmReceiptOrder,
    closeModalConfirmReceiptOrder,
    selectedNegotiationConfirmReceiptOrder,
    formDataConfirmReceiptOrder,
    handleChange,
    handlePhoneChange,
    handleBlur,
    handleSubmit,
    loadingConfirmReceiptOrder,
    errorConfirmReceiptOrder,
    successConfirmReceiptOrder,
    errorsConfirmReceiptOrder,
  };
};

export default UseModalConfirmReceiptOrder;
